import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const OkxTradeList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_subscription_id",
        title: "Bot-subscription Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 250,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "trade_id",
        title: "Trade Id",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "pnl",
        title: "Pnl",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "px",
        title: "Px",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "sz",
        title: "Size",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "inst_type",
        title: "Inst-type",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "bal",
        title: "Bal",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "bal_chg",
        title: "Bal Chg",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "pos_bal",
        title: "Pos Bal",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "pos_bal_chg",
        title: "Pos Bal Chg",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "inst_id",
        title: "Inst Id",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "interest",
        title: "Interest",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "ord_id",
        title: "Order Id",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "cl_ord_id",
        title: "Client-order Id",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "bill_id",
        title: "Bill Id",
        type: "number",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "tag",
        title: "Tag",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "exec_type",
        title: "Exec Type",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ccy",
        title: "Ccy",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "fee",
        title: "Fee",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "timestamp",
        title: "Timestamp",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_fwd_px",
        title: "Fill Fwd Px",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_idx_px",
        title: "Fill Idx Px",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_mark_px",
        title: "Fill Mark Px",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_mark_vol",
        title: "Fill Mark Vol",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_px_usd",
        title: "Fill Px Usd",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_px_vol",
        title: "Fill Px vol",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fill_time",
        title: "Fill Time",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "type",
        title: "Type",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "sub_type",
        title: "Sub Type",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "to",
        title: "to",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "from",
        title: "from",
        type: "number",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "mgn_mode",
        title: "Margin Mode",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "notes",
        title: "Notes",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey={(record) => record.bill_id}
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
